<template>
    <div v-if="!loading" class="modal-card" style="width: 65vw; height:70vh">
        <header class="modal-card-head">
            <p class="modal-card-title" v-text="product.name"></p>
            <button
                type="button"
                class="delete"
                @click="$emit('close')"/>
        </header>
        <section class="modal-card-body">
            <div class="mb-3" v-for="retailer in retailers" :key="retailer.id">
                <p v-text="retailer.name" class="is-size-5 font-weight-bold mb-2"></p>
                <b-table :data="tableData(retailer.id)"
                         striped bordered>
                    <b-table-column label="Website" v-slot="props">
                        {{ props.row.website.name }}
                    </b-table-column>
                    <b-table-column label="Price" v-slot="props">
                        {{ props.row.price.price }}
                    </b-table-column>
                    <b-table-column label="Special Price" v-slot="props">
                        {{ props.row.price.special_price }}
                    </b-table-column>
                    <b-table-column label="Discount Percentage" v-slot="props">
                        {{ getDiscountPercentage(props.row.price) }}%
                    </b-table-column>
                    <b-table-column label="Currency" v-slot="props">
                        {{ getCurrency(props.row.price, retailer.id).currency }}
                    </b-table-column>
                </b-table>
            </div>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end">
            <b-button @click="$emit('close')">
                {{ __('strings.close') }}
            </b-button>
        </footer>
    </div>
</template>

<script>
    export default {
        props: {
            product: {
                type: Object,
                requested: true
            },
            retailers: {
                type: Array,
                requested: true
            }
        },
        data() {
            return {
                prices: [],
                loading: true
            }
        },
        mounted() {
            this.getPrices();
        },
        methods: {
            tableData(retailerId) {
                return this.prices ? this.prices[retailerId] : [];
            },
            getCurrency(price, retailer_id) {
                return _.find(price.website.currencies, {retailer_id})
            },
            getDiscountPercentage(price) {
                let discount = price.special_price ? price.special_price : price.price;
                return Math.ceil(((price.price - discount) / price.price) * 100);
            },
            async getPrices() {
                this.loading = true;
                await axios.get(`product/websitePrices/${this.product.id}`)
                    .then(response => {
                        this.prices = response.data
                        this.loading = false;
                    })
            }
        }
    }
</script>